var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverZakaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.369,
    height: 19.48,
    viewBox: "0 0 24.369 19.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358",
    transform: "translate(-11349.716 22125.627)",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M9.36,10.979c-1.617,1.344-4.768-.224-7.335-3.256S.062,0,.062,0,4.83.224,7.4,3.256s3.58,6.378,1.963,7.723",
    transform: "translate(11353.718 -22122.082)",
    fill: "#4f505e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M3.507,14.331c2.112,0,3.507-3.208,3.507-7.166S3.507,0,3.507,0,0,3.208,0,7.165s1.4,7.166,3.507,7.166",
    transform: "translate(11358.394 -22124.949)",
    fill: "#4f505e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.781,10.979c1.618,1.344,4.768-.224,7.335-3.256S10.079,0,10.079,0,5.311.224,2.744,3.256-.837,9.634.781,10.979",
    transform: "translate(11359.941 -22122.082)",
    fill: "#4f505e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M0,2.8A7.8,7.8,0,0,1,.551,0,7.894,7.894,0,0,1,2.722,1.754C5.29,4.785,6.3,8.132,4.685,9.477a2.143,2.143,0,0,1-1.283.48C1.35,9.851,0,6.687,0,2.8",
    transform: "translate(11358.394 -22120.58)",
    fill: "#4f505e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M5.466,2.8A7.807,7.807,0,0,0,4.915,0,7.9,7.9,0,0,0,2.744,1.754C.176,4.785-.837,8.132.781,9.477a2.144,2.144,0,0,0,1.283.48c2.052-.105,3.4-3.269,3.4-7.16",
    transform: "translate(11359.941 -22120.58)",
    fill: "#4f505e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M1.955,10.27.486,6.411C-.552,5.089.135,2.526,1.955,0c1.82,2.526,2.507,5.089,1.47,6.411Z",
    transform: "translate(11359.945 -22117.822)",
    fill: "#4f505e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M0,8.727C-.074,6.433,1.447,3.746,4.113,1.9S9.848-.45,12,.406a15.193,15.193,0,0,0-6.955,2.8A15.015,15.015,0,0,0,0,8.727",
    transform: "translate(11361.902 -22116.133)",
    fill: "#4f505e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M12,8.727c.076-2.294-1.444-4.982-4.111-6.831S2.149-.45,0,.406a15.193,15.193,0,0,1,6.955,2.8A15.018,15.018,0,0,1,12,8.727",
    transform: "translate(11349.9 -22116.133)",
    fill: "#4f505e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverZakaut);
export default __webpack_public_path__ + "static/media/silverZakaut.3c2153ace7ea96713265c36e71c709ce.svg";
export { ForwardRef as ReactComponent };